/**
 *
 *  PrevButton
 *  TruBe Date Time AvailabilityCalendar Previous Button Component
 *
 *  Created by Vladimir Shishlyannikov on 18/11/2022.
 *  Copyright (c) 2016-present iWoo Ltd. All rights reserved.
 *
 */

import React from "react";

export default function PrevButton({
  className,
  buttonClassName,
  onPress,
  visible,
}) {
  return (
    <div
      className={`button-control button-next tbk-absolute tbk-z-10 tbk-flex tbk-h-full tbk-items-end tbk-opacity-0 md:tbk-transition-opacity md:tbk-duration-200 md:tbk-ease-in-out ${
        visible ? "md:tbk-opacity-100" : "tbk-opacity-0"
      }${className ? ` ${className}` : ""}`}
    >
      <button
        className={`${buttonClassName} calendar-btn tbk-inline-flex tbk-h-4 tbk-w-4 tbk-items-center tbk-justify-center tbk-rounded-full tbk-bg-basic-white tbk-text-blue-dark tbk-shadow-trube `}
        onClick={onPress}
      >
        <svg
          width="8"
          height="13"
          viewBox="0 0 8 13"
          xmlns="http://www.w3.org/2000/svg"
          style={{
            display: "block",
            fill: "currentcolor",
          }}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 1.5L6.5 -3.93402e-07L-1.70474e-06 6.5L6.5 13L8 11.5L3 6.5L8 1.5Z"
          />
        </svg>
      </button>
    </div>
  );
}
